import React, { useRef, useState } from 'react'
import { TextInput } from "@mantine/core";
import ToogleButton from '../ToogleButton/ToogleButton';
import { setNewPassword } from '../../services/authenticationService';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { useNavigate } from 'react-router-dom';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';


function PasswordReset() {
  const CUR_COMPONENT = "PasswordReset"
  const { translate } = usePortalTranslation();
    const Newpassword = useRef<HTMLInputElement>(null);
    const ConfirmPassword = useRef<HTMLInputElement>(null);
    const [toggleState, setToggleState] = useState<boolean>(false);
    const navigate = useNavigate();

    const setpassword = async () => {
        setToggleState(!toggleState);
        const NewpasswordValue: string = Newpassword.current?.value!;
        const ConfirmPasswordValue: string = ConfirmPassword.current?.value!;
        if (NewpasswordValue === ConfirmPasswordValue && NewpasswordValue.length) {
          try {
            const response = await setNewPassword(NewpasswordValue);
            if (
              response.status === 200 &&
              (response.data?.Message === "Password changed successfully" || response.response.data?.Message === "Password changed successfully")
            ) {
              openPopup("Success", "Password has been changed successfully");
              return navigate("/dashboardLogin");
            } else {
              openPopup("Error", response?.data?.message ?? response.response.data?.message ?? "An error occurred while changing the password");
            }
          } catch (error) {
            openPopup("Error", "Passwords do not match");
          }
        } else {
          openPopup("Error", "Passwords do not match");
        }
        setToggleState(false);
      };

  return (
    <form className="loginInputs">
    <TextInput
      autoComplete="off"
      sx={{ width: "70%", borderRadius: "7rem" }}
      id="NewPassword"
      type="password"
      placeholder= {translate(TranslationEnum.password_reset,"Enter New Password")}
      readOnly
      onFocus={(e) => e.target.removeAttribute("readOnly")}
      ref={Newpassword}
    />
    <TextInput
      autoComplete="off"
      sx={{ width: "70%", marginTop: "5%", borderRadius: "7rem" }}
      id="ConfirmNewPassword"
      placeholder={translate(TranslationEnum.password_reset,"Confirm New Password")}
      type="password"
      readOnly
      onFocus={(e) => e.target.removeAttribute("readOnly")}
      ref={ConfirmPassword}
    />
    <ToogleButton
      status1="SUBMIT"
      status2="SUBMITTING"
      handleChange={setpassword}
      updateToggleState={toggleState}
    />
  </form>
  )
}

export default PasswordReset